/**
 * Class description
 *
 * Created: 2017-10-09
 * @author jonas
 */
import {
    ISymbolStateConfig,
    StateReelSymbol,
    SymbolStateTransition
} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite} from "gsap";
import {DungeonQuestHelper} from "../bigSymbols/DungeonQuestHelper";
import {DungeonQuestGameAssets} from "../DungeonQuestGameAssets";
import {DungeonQuestGameConfig} from "../DungeonQuestGameConfig";


export class DungeonQuestBaseReelSymbol extends StateReelSymbol {
    private _winSpark:PIXI.Sprite;
    private _winParticles:TimelineSprite;
    private _endParticles:TimelineSprite;
    private _localSymbolName:string;

    get desatOverlay():PIXI.Sprite {
        return this._whiteNormalOverlay;
    }

    get whiteOverlay():PIXI.Sprite {
        return this._whiteNormalOverlay;
    }

    private _desaturatedOverlay:PIXI.Sprite;
    private _whiteNormalOverlay:PIXI.Sprite;


    constructor(symName:string, reelId:number, state?:ISymbolStateConfig) {
        super(symName, reelId, state);
    }


    protected initAnimations():void {
        this._endParticles = new TimelineSprite(GameResources.getTextures(DungeonQuestGameAssets.SYMBOL_WIN_END_PARTICLES));
        this._endParticles.anchor.set(0.5, 0.5);
        this._endParticles.tint = DungeonQuestHelper.getSymbolColor(this.symName);
        const scale = DungeonQuestHelper.isLowWin(this.symName) ? 0.75 : 1;
        const flipFactor = Math.random() < 0.5 ? 1 : -1;
        this._endParticles.scale.set(scale * flipFactor, scale);
        this._endParticles.blendMode = PIXI.BLEND_MODES.ADD;
        this._endParticles.hide();

    }

    /*
    protected initAnimations():void {
        if (this.symName == DungeonQuestSymbols.NONE){
            return;
        }
        this._whiteNormalOverlay = new PIXI.Sprite(
            FifthElement.colorEffectTextureCache.getWhiteTexture(
                FifthElementGameAssets.getSymbolStateTextures(this.symName, FifthElementGameConfig.instance.SYMBOL_STATES.normal.keyword)[0])
        );
        this._whiteNormalOverlay.anchor.set(0.5, 0.5);

        this._desaturatedOverlay = new PIXI.Sprite(
            FifthElement.colorEffectTextureCache.getDesaturatedTexture(
                FifthElementGameAssets.getSymbolStateTextures(this.symName, FifthElementGameConfig.instance.SYMBOL_STATES.normal.keyword)[0], 0.5)
        );
        this._desaturatedOverlay.anchor.set(0.5, 0.5);

/!*
        this._winSpark = new PIXI.Sprite(GameResources.getTextures(FifthElementGameAssets.SYMBOL_WIN_SPARK_LOW)[0]);
        this._winParticles = new TimelineSprite(GameResources.getTextures(FifthElementGameAssets.SYMBOL_WIN_END_PARTICLES));*!/

        this.hideWhiteOverlay();
        this.hideDesatOverlay();

    }
*/

    protected showDesatOverlay(alpha:number, tint:number, blendMode:number) {
        this.addChild(this._desaturatedOverlay);
        this._desaturatedOverlay.alpha = alpha;
        this._desaturatedOverlay.tint = tint;
        this._desaturatedOverlay.blendMode = blendMode;
    }

    protected hideDesatOverlay() {
        this.removeChild(this._desaturatedOverlay);
    }

    protected showWhiteOverlay(alpha:number, tint:number, blendMode:number) {
        this.addChild(this._whiteNormalOverlay);
        this._whiteNormalOverlay.alpha = alpha;
        this._whiteNormalOverlay.tint = tint;
        this._whiteNormalOverlay.blendMode = blendMode;
    }

    protected hideWhiteOverlay() {
        this.removeChild(this._whiteNormalOverlay);
    }

    public moveSymbolToTop() {
        if(this.parent != null) {
            this.parent.addChild(this);
            this.addChild(this._endParticles);

        }
    }

    private isAWinState(stateName:string):boolean {
        if(stateName == DungeonQuestGameConfig.instance.SYMBOL_STATES.win.keyword ||
            stateName == DungeonQuestGameConfig.instance.SYMBOL_STATES.win2.keyword ||
            stateName == DungeonQuestGameConfig.instance.SYMBOL_STATES.win3.keyword) {
            return true;
        }
        return false;
    }

    protected addNewStateAnimation(timeline:TimelineLite, newState:SymbolStateTransition, stateAnimation:TimelineSprite, delay:number):void {
        super.addNewStateAnimation(timeline, newState, stateAnimation, delay);

        if(this.isAWinState(newState.state.keyword)) {
            const tl:TimelineLite = new TimelineLite();
            tl.add(() => this.addChild(this._endParticles));
            tl.add(() => this._endParticles.getAnimationAutoShowHide(true, true));
            timeline.add(tl, "-=0.36");
        }

        if(newState.state.keyword == DungeonQuestGameConfig.instance.SYMBOL_STATES.winToggle.keyword ||
            newState.state.keyword == DungeonQuestGameConfig.instance.SYMBOL_STATES.normal.keyword) {
            timeline.add(() => this.addChild(this._endParticles), 0);
        }
        /*

                const tl:TimelineLite = new TimelineLite();
                tl.add(() => this.hideDesatOverlay());

                if(newState.state.keyword === FifthElementGameConfig.instance.SYMBOL_STATES.win.keyword) {
                    tl.add(() => this.moveSymbolToTop());
                    tl.add(() => this.showWhiteOverlay(0, 0xffffff, PIXI.BLEND_MODES.ADD));

                    tl.add(new TweenLite(this.scale, 0.2, {x : 0.7, y : 0.7}));
                    tl.add([
                        new TweenLite(this.scale, 0.5, {x : 1.2, y : 1.2, ease : Back.easeOut.config(1.7)}),
                        new TweenLite(this.whiteOverlay, 0.3, {alpha : 0.1})
                    ]);
                    tl.add([
                        new TweenLite(this.scale, 0.3, {x : 1, y : 1}),
                        new TweenLite(this.whiteOverlay, 0.3, {alpha : 0})
                    ], "+=0.5");

                    tl.add(() => this.hideWhiteOverlay());
                }

                if(newState.state.keyword === FifthElementGameConfig.instance.SYMBOL_STATES.noWin.keyword) {
                    tl.add(() => this.showWhiteOverlay(0, 0x3c2f4a, PIXI.BLEND_MODES.MULTIPLY));
                    tl.add(new TweenLite(this.whiteOverlay, 0.1, {alpha : 0.6}));
                }

                if(newState.state.keyword === FifthElementGameConfig.instance.SYMBOL_STATES.transform.keyword && this.symName != "W") {
                    tl.add(() => this.moveSymbolToTop());
                    tl.add(() => this.showWhiteOverlay(0, 0xffffff, PIXI.BLEND_MODES.ADD));

                    tl.add(new TweenLite(this.whiteOverlay, 0.2, {alpha : 1}));
                    tl.add(new TweenLite(this.whiteOverlay, 0.4, {alpha : 0, ease : Linear.easeNone}), 0.8);
                    tl.add(() => this.hideWhiteOverlay());
                }

                if(newState.state.keyword === FifthElementGameConfig.instance.SYMBOL_STATES.attention.keyword) {
                    tl.add(() => this.moveSymbolToTop());
                    tl.add(() => this.showWhiteOverlay(0, 0xffffff, PIXI.BLEND_MODES.ADD));

                    tl.add(new TweenLite(this.whiteOverlay, 0.2, {alpha : 1}));
                    tl.add(new TweenLite(this.whiteOverlay, 0.4, {alpha : 0, ease : Linear.easeNone}), 0.8);
                    tl.add(() => this.hideWhiteOverlay());
                }
        */

        /*
                if(newState.state.keyword === FifthElementGameConfig.instance.SYMBOL_STATES.highlighted.keyword) {
                    tl.add(() => this.moveSymbolToTop());
                    tl.add(() => this.showDesatOverlay(0.5, 0xffffff, PIXI.BLEND_MODES.ADD));
                }
                if(newState.state.keyword === FifthElementGameConfig.instance.SYMBOL_STATES.dimmed.keyword) {
                    tl.add(() => this.showWhiteOverlay(0.6, 0x3c2f4a, PIXI.BLEND_MODES.MULTIPLY));
                }

                if(newState.state.keyword === FifthElementGameConfig.instance.SYMBOL_STATES.spin.keyword || newState.state.keyword === FifthElementGameConfig.instance.SYMBOL_STATES.reelStop.keyword) {
                    if(DungeonQuestSymbolUtil.isHighlightedSpin()) {
                        if(DungeonQuestSymbolUtil.isHighlightedSym(this.symName)) {
                            tl.add(() => this.moveSymbolToTop());
                            tl.add(() => this.showDesatOverlay(0.5, 0xffffff, PIXI.BLEND_MODES.ADD));
                        } else {
                            tl.add(() => this.showWhiteOverlay(0.6, 0x3c2f4a, PIXI.BLEND_MODES.MULTIPLY));
                        }
                    }
                }*/


        // timeline.add(tl, delay);
    }

    protected addOldStateAnimation(timeline:TimelineLite, transition:SymbolStateTransition, stateAnimation:TimelineSprite, delay:number):void {
        super.addOldStateAnimation(timeline, transition, stateAnimation, delay);

    }
}